import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'rdsStripHtml',
})
export class RdsStripHtmlPipe implements PipeTransform {
  transform(value: string | null | undefined): SafeHtml | null | undefined {
    if (value) {
      return value ? value.replace(/<[^>]*>/g, '') : '';
    }
    return value;
  }
}

@NgModule({
  exports: [RdsStripHtmlPipe],
  declarations: [RdsStripHtmlPipe],
})
export class RdsStripHtmlPipeModule {}
